var map = {
	"./id_bg.png": 806,
	"./三重一大管理.png": 4857,
	"./任务.png": 6642,
	"./公告.png": 5855,
	"./公文.png": 122,
	"./公文流转.png": 4673,
	"./公章管理.png": 7324,
	"./处室名称.png": 1802,
	"./工资考核.png": 9591,
	"./待办.png": 6140,
	"./报修.png": 652,
	"./教师任职管理.png": 206,
	"./文件.png": 2542,
	"./校级红头文管理.png": 7329,
	"./档案管理.png": 7977,
	"./荣誉管理.png": 7820,
	"./角色.png": 2717,
	"./设备采购.png": 9520,
	"./课时量管理.png": 807,
	"./资产.png": 2626,
	"./食堂.png": 3442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4464;